module.exports = __webpack_public_path__ + "img/iconfont.a539ea8f.svg";